import { Target, Users, TrendingUp, FileText } from 'lucide-react';

/**
 * RaiseSection — the fundraising focus of the Raisy homepage (theme-adaptive,
 * mobile friendly). Leads the page story: from company URL to a governed
 * fundraising machine, AI-assisted and human-directed (Human Manifesto).
 */

const raiseSteps = [
  {
    icon: <Target className="w-6 h-6" />,
    title: 'Investor Research',
    description:
      'Raisy builds investor lists that fit your story, scores fit, and keeps every preference in one shared memory.',
  },
  {
    icon: <Users className="w-6 h-6" />,
    title: 'Warm Outreach',
    description:
      'Personalized, multi-channel outreach drafted by AI and gated by you — nothing goes out without your call.',
  },
  {
    icon: <TrendingUp className="w-6 h-6" />,
    title: 'Pipeline & Updates',
    description:
      'Every touchpoint tracked, every meeting logged, every follow-up on schedule — with receipts for all of it.',
  },
  {
    icon: <FileText className="w-6 h-6" />,
    title: 'Term-Sheet Tracking',
    description:
      'Terms, deadlines, and decisions tracked in one auditable trail — so nothing slips between the emails.',
  },
];

export const RaiseSection = () => {
  return (
    <section className="bg-slate-50 dark:bg-slate-950 py-20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-cyan-50 dark:bg-cyan-900/20 text-cyan-700 dark:text-cyan-400 rounded-full text-sm font-medium border border-cyan-200 dark:border-cyan-800 mb-4">
            The Raise
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 dark:text-white mb-4">
            From Company URL to Fundraising Machine
          </h2>
          <p className="text-xl text-slate-600 dark:text-slate-300 max-w-3xl mx-auto">
            Raisy turns your company into a fundraising operation — investor research, warm outreach, pipeline
            tracking, and updates — AI-assisted, human-directed, fully audited.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {raiseSteps.map((s, idx) => (
            <div
              key={idx}
              className="p-6 rounded-lg border border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900/60"
              data-aos="fade-up"
              data-aos-delay={idx * 100}
            >
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-cyan-100 to-teal-100 dark:from-cyan-900 dark:to-teal-900 flex items-center justify-center text-cyan-600 dark:text-cyan-400 mb-4">
                {s.icon}
              </div>
              <h3 className="text-lg font-semibold text-slate-900 dark:text-white mb-2">{s.title}</h3>
              <p className="text-sm text-slate-600 dark:text-slate-300">{s.description}</p>
            </div>
          ))}
        </div>

        <p className="mt-12 text-center text-slate-500 dark:text-slate-400 max-w-2xl mx-auto">
          One memory across every step of the raise. Your people at every decision gate. The same engine then runs
          the rest of your company.
        </p>
      </div>
    </section>
  );
};
